import { forwardRef } from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";

import {
  type TAccordionItemElement,
  type TAccordionItemProps,
} from "@/ui/components/data-display/Accordion/Accordion.config";
import { cn } from "@/ui/lib/utils";

export const AccordionItem = forwardRef<TAccordionItemElement, TAccordionItemProps>(
  (
    {
      className,
      disabled,
      ...props
    },
    ref,
  ) => (
    <AccordionPrimitive.Item
      data-component="AccordionItem"
      ref={ref}
      disabled={disabled}
      className={cn(
        "border border-solid border-muted",
        "rounded-sys-md",
        "shadow-sm focus-within:shadow-none",
        !disabled && "hover:shadow-lg",
        "focus-within:border-state-focus",
        "focus-within:ring-4 focus-within:ring-focus-secondary",
        className,
      )}
      {...props}
    />
  ),
);

AccordionItem.displayName = AccordionPrimitive.Item.displayName;
